/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { useEffect } from 'react';
import { Grid, Fade } from '@mui/material';
import { useSelector } from 'react-redux';
import styles from 'modules/dashboard/components/tab-container/tab-container.module.scss';
import UseVisualSwap from 'modules/dashboard/components/tab-container/trend-tabs/hooks/use-visual-swap';
import Widget from 'modules/dashboard/components/tab-container/trend-tabs/components/widget-pane/trend-widgets';
import useTrendTime from 'modules/dashboard/components/tab-container/trend-tabs/hooks/use-trend-time';
import useTrendHotel from 'modules/dashboard/components/tab-container/trend-tabs/hooks/use-trend-hotel';
import useTrendSegment from 'modules/dashboard/components/tab-container/trend-tabs/hooks/use-trend-segment';
import useGenerateTrendUrl from '../../hooks/use-generate-trend-url';
import { selectTabList } from '../../../../../selectors';
/**
 * Trend widget parent component
 * @param {Number} value - Trend time widget tab value
 * @param {Boolean} active - whether trend time tab is active
 * @param {Boolean} toggleDisabled - PMS sync toggle disabled state
 * @param {Date} latestDate - Latest booking date of selected hotel
 * @param {String} hotelTimezone - Timezone of selected hotel
 * @param {String} reportType - Report type of active tab
 */
const TrendWidget = ({ active, value, latestDate, reportType, hotelTimezone, toggleDisabled }) => {
  UseVisualSwap();
  useTrendTime();
  useTrendHotel();
  useTrendSegment();
  useGenerateTrendUrl();
  //
  const TAB_VALUE = useSelector(selectTabList);
  // Triggered when tab value or active tab change
  useEffect(() => {
    // Scroll up when the trend time tab is clicked
    if (value === TAB_VALUE.TREND_TIME) window.scrollTo(0, 0);
  }, [value, active]);
  //
  return (
    active && (
      <Fade in={active} {...{ timeout: 500 }}>
        <Grid
          container
          direction="row"
          sx={{
            display: value === TAB_VALUE.TREND_TIME ? '' : 'none',
          }}
          className={styles.mainGrid}
          alignItems="flex-start"
        >
          <Widget
            value={value}
            latestDate={latestDate}
            reportType={reportType}
            hotelTimezone={hotelTimezone}
            toggleDisabled={toggleDisabled}
          />
        </Grid>
      </Fade>
    )
  );
};
//
export default TrendWidget;
